import classNames from 'classnames';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl} from 'react-intl';
import { message } from 'antd';
import BufferedInputHOC from '../forms/buffered-input-hoc.jsx';
import Input from '../forms/input.jsx';
const BufferedInput = BufferedInputHOC(Input);

import './project-title-input.css';
import { useSelector, useDispatch } from 'react-redux'
import { setProjectTitle, setProjectTitleold } from '../store/project-state' 

const messages = defineMessages({
    projectNameRules: {
        id: 'gui.mywork.projectNameRules',
        defaultMessage: 'Project Name contain 1 to 30 characters',
        description: 'Project Name contain 1 to 30 characters'
    }
});

const ProjectTitleInput = ({
    className,
    intl
}) => {
    const title = useSelector((state) => state.projectStore.title)
    
    const dispatch = useDispatch()
    const onSubmit = (ti) => {
        dispatch(setProjectTitle(ti))
    }
    const handleBlur = async (e) => {
        // 当按回车时，e 可能是 undefined，此时使用 Redux store 中的 title
        const rawTitle = (e?.target?.value || title || '').trim()
        if (!rawTitle) return
        let countLimitCondition = null
        let specialCharacterCondition = null
        if (rawTitle) {
            var name = rawTitle.replace(/\.py$/, "");
            // 字符数字限制
            countLimitCondition = rawTitle.length > 30 || rawTitle.length < 1;
            // 限制特殊字符
            specialCharacterCondition = /[`~!@#$%^&*\-+=<>?:"{}|.,\/;'\\[\]·~！@#￥%……&*——\-+={}|《》？：“”【】、；‘’，。、]/.test(name);
        }
        if (!rawTitle || countLimitCondition || specialCharacterCondition) {
            message.error(intl.formatMessage(messages.projectNameRules));
            // 恢复到之前的有效值
            const previousTitle = localStorage.getItem('projectTitle') || '';
            dispatch(setProjectTitle(previousTitle));
            return
        }
        localStorage.setItem('pyName', rawTitle)
    }
    return <BufferedInput
        className={`titleField ${className}`}
        maxLength="100"
        placeholder="在此填写作品标题"
        // placeholder={intl.formatMessage(messages.projectTitlePlaceholder)}
        value={title}
        tabIndex="0"
        type="text"
        // disabled="true"
        onSubmit={onSubmit}
        onBlur={handleBlur}
    />
};

export default ProjectTitleInput;
